import * as Yup from 'yup';

const schema = Yup.object().shape({
  email: Yup.string()
    .email('schemaValidationErrors.invalidEmail')
    .required('schemaValidationErrors.emailRequired'),
  password: Yup.string().required('schemaValidationErrors.passwordRequired'),
});
export default schema;
